import { createContext } from "react";

export const GameContext = createContext();

export default GameContext;
